import React from 'react';
import Alert from '@material-ui/lab/Alert';
import './CustomAlert.scss';

const CustomAlert = ({text, severity = 'warning', customText, isList}) => {
  return (
    <Alert icon={false} severity={severity} className={isList ? 'muiAlert mt--20' : 'muiAlert'}>
        {customText ? text : 'No se encontraron ' + text}
    </Alert>
  );
};

export default CustomAlert;
